export enum MeasurementType {
    Point = "Point",
    Distance = "Distance",
    Polyline = "Polyline",
    Area = "Area",
    Volume = "Volume"
}
